<template>
  <div>
    <v-row>
      <v-col>
        Show this category if {{ parentNodeName }} value (currently
        {{ parentRecordCurrentValue }}) is
        <v-select
          :items="conditionalOperations"
          v-model="conditionalOperationsChoice"
        ></v-select>
        <v-text-field
          hide-details
          single-line
          type="number"
          v-model="conditionalValue"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: {
    node: Object,
    parentNodeId: String,
    parentNodeName: String,
    selectedRecord: Object,
    parentRecord: Object,
    index: Number,
    prexistingCondition: String
  },
  computed: {
    parentRecordCurrentValue: function() {
      if (this.parentRecord.value.length) {
        return this.parentRecord.value[this.parentRecord.value.length - 1]
          .val[0];
      } else {
        return "Not Set";
      }
    },
    conditionValueAndConditionOpChoice: function() {
      // this is a hack for vue v2.6 to get the watch to run whenever the following are updated
      return (
        this.conditionalValue, this.conditionalOperationsChoice, Date.now()
      );
    }
  },
  watch: {
    conditionValueAndConditionOpChoice() {
      let conditionHolder =
        "$parent " +
        this.conditionalOperationsSymbols[
          this.conditionalOperations.indexOf(this.conditionalOperationsChoice)
        ] +
        " " +
        this.conditionalValue;

      let conditionObject = {
        condition: conditionHolder,
        index: this.index
      };
      this.$emit("setCondition", conditionObject);
    }
  },
  created() {
    if (this.prexistingCondition) {
      this.conditionalOperationsChoice = this.conditionalOperations[
        this.conditionalOperationsSymbols.indexOf(
          this.prexistingCondition.split(" ")[
            this.prexistingCondition.split(" ").length - 2
          ]
        )
      ];
      this.conditionalValue = this.prexistingCondition.split(" ")[
        this.prexistingCondition.split(" ").length - 1
      ];
    }
  },
  data() {
    return {
      conditionalOperations: ["Equal To", "Greater Than", "Less Than"],
      conditionalOperationsSymbols: ["==", ">", "<"],
      conditionalOperationsChoice: "Equal To",
      conditionalValue: this.node.meta.value
    };
  },
  methods: {}
};
</script>

<style></style>
